import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollRestoration = () => {
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    const savedPosition = sessionStorage.getItem(`scroll-${pathname}`);

    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition));
    } else {
      window.scrollTo(0, 0);
    }

    return () => {
      sessionStorage.setItem(`scroll-${pathname}`, window.scrollY.toString());
    };
  }, [pathname]);
};
